const searchItems = [
  { name: "SALE'S CRM", path: "/crm-feature-section" },
  { name: "CORE ERP", path: "/erp-feature-section" },
  { name: "Payroll Management", path: "/payroll-management" },
  { name: "Inventory Management", path: "/inventory-management" },
  { name: "Project Management", path: "/project-management" },
  { name: "Production", path: "/production" },
  { name: "Process Management", path: "/process-management" },
  { name: "Menufecturing", path: "/menufecturing-management" },
  { name: "AMC & CMC", path: "/cloud-solutions" },
  { name: "Accounting", path: "/account-management" },
];

export default searchItems;
